import { createAction, props } from '@ngrx/store';
import { FaqCategory } from '../../models';

export const LoadFaqCategories = createAction('[Category] Load Categories');
export const LoadFaqCategoriesSuccess = createAction('[Category] Load Categories Success', props<{ categories: FaqCategory[] }>());
export const LoadFaqCategoriesFail = createAction('[Category] Load Categories Fail', props<{ error: any }>());

export const ClearFaqCategories = createAction('[Category] Clear Categories');
